import { appConfigSelectors } from "../slices/appConfigSlice";
import { useAppSelector } from "../redux/hooks";

export const useFirestoreBasePath = () => useAppSelector(appConfigSelectors.selectFirestoreBasePath);
